<template>
  <div>
    <hr class="mt-0" />

    <div class="row mt-4">
      <div class="col-md-8 col-lg-6">
        <p class="fw-semibold font-size-3 mb-1">Booking email recipients</p>
        <p class="text-muted font-size-1 mb-4">
          Used for farm stay confirmation and cancellation emails. Leave blank to keep env defaults.
        </p>

        <div v-if="loading" class="text-muted mb-3">Loading…</div>

        <form v-else @submit.prevent="save">
          <div class="mb-3">
            <label class="form-label fw-semibold">Ops TO</label>
            <input
              type="email"
              class="form-control"
              v-model="form.operation_teams_to"
              placeholder="ops@example.com"
              required
            />
            <div class="form-text">Primary recipient for ops notification emails.</div>
          </div>

          <div class="mb-3">
            <label class="form-label fw-semibold">Ops CC</label>
            <input
              type="text"
              class="form-control"
              v-model="opsCcText"
              placeholder="person1@example.com, person2@example.com"
            />
            <div class="form-text">Comma-separated. CC on ops notification emails.</div>
          </div>

          <div class="mb-4">
            <label class="form-label fw-semibold">Customer email CC</label>
            <input
              type="text"
              class="form-control"
              v-model="customerCcText"
              placeholder="person1@example.com, person2@example.com"
            />
            <div class="form-text">Comma-separated. CC on customer confirmation emails.</div>
          </div>

          <button type="submit" class="btn btn-primary" :disabled="saving">
            {{ saving ? 'Saving…' : 'Save' }}
          </button>
          <span v-if="saveMessage" class="ms-3 text-success fw-semibold">{{ saveMessage }}</span>
          <span v-if="errorMessage" class="ms-3 text-danger fw-semibold">{{ errorMessage }}</span>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FarmStayEmailSettings',
  data() {
    return {
      loading: true,
      saving: false,
      saveMessage: '',
      errorMessage: '',
      form: {
        operation_teams_to: '',
        operation_teams_cc: [],
        operation_teams_cc_in_customer_email: [],
      },
      opsCcText: '',
      customerCcText: '',
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    parseEmails(text) {
      if (!text || !String(text).trim()) return [];
      return [
        ...new Set(
          String(text)
            .split(/[,;]+/)
            .map((e) => e.trim())
            .filter(Boolean)
        ),
      ];
    },
    async load() {
      this.loading = true;
      this.errorMessage = '';
      try {
        const res = await this.$apiV1.get('/farm-stay/email-settings');
        if (res.data?.success && res.data.data) {
          const d = res.data.data;
          this.form.operation_teams_to = d.operation_teams_to || '';
          this.form.operation_teams_cc = d.operation_teams_cc || [];
          this.form.operation_teams_cc_in_customer_email =
            d.operation_teams_cc_in_customer_email || [];
          this.opsCcText = (d.operation_teams_cc || []).join(', ');
          this.customerCcText = (d.operation_teams_cc_in_customer_email || []).join(', ');
        }
      } catch (err) {
        this.errorMessage = err.response?.data?.message || 'Failed to load email settings';
      } finally {
        this.loading = false;
      }
    },
    async save() {
      this.saving = true;
      this.saveMessage = '';
      this.errorMessage = '';
      try {
        const payload = {
          operation_teams_to: this.form.operation_teams_to.trim(),
          operation_teams_cc: this.parseEmails(this.opsCcText),
          operation_teams_cc_in_customer_email: this.parseEmails(this.customerCcText),
        };
        const res = await this.$apiV1.put('/farm-stay/email-settings', payload);
        if (res.data?.success) {
          const d = res.data.data || payload;
          this.form.operation_teams_to = d.operation_teams_to || '';
          this.opsCcText = (d.operation_teams_cc || []).join(', ');
          this.customerCcText = (d.operation_teams_cc_in_customer_email || []).join(', ');
          this.saveMessage = 'Saved';
          setTimeout(() => {
            this.saveMessage = '';
          }, 2500);
        } else {
          this.errorMessage = res.data?.message || 'Failed to save';
        }
      } catch (err) {
        this.errorMessage = err.response?.data?.message || 'Failed to save email settings';
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
